export default __webpack_public_path__ + "static/media/token_security.1edeeaad.svg";